import { useLazyQuery, useMutation } from "@apollo/client/react";
import { useCallback } from "react";

import {
  mutationDocuments,
  queryDocuments,
} from "@smart/manage-gql-operations-dom";

export const useLazyLoadContacts = () => {
  const [load] = useLazyQuery(queryDocuments.contacts, {
    fetchPolicy: "no-cache",
  });

  return useCallback(
    async (variables: {
      names?: string[];
      emails?: string[];
      phones?: string[];
    }) => {
      const result = await load({ variables });
      return result.data?.contacts;
    },
    [load],
  );
};

export const useUpdateContact = () =>
  useMutation(mutationDocuments.updateContact);
